import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";

import Label from "../../components/label";
import Section from "../../components/section";
import Download from "../../components/svg/download";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    getBlogsQuery,

    handleDownAssementFile,
    handleDownResumeFile,
  } = useBlogsProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto">
      <div className="mt-3 overflow-x-auto mb-10">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr className="grid grid-cols-11 w-full">
              <th className="border font-normal border-gray-300 px-1 py-2 col-span-1 text-left">
                SR No.
              </th>
              <th className="border font-normal border-gray-300 px-2 py-2 col-span-2 text-left">
                Name
              </th>
              <th className="border font-normal border-gray-300 px-2 py-2 col-span-2 text-left">
                Phone
              </th>
              <th className="border font-normal border-gray-300 px-2 py-2 col-span-2 text-left">
                Designation
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 col-span-2 flex items-center justify-center">
                Assessment File
              </th>
              <th className="border font-normal border-gray-300 px-4 py-2 col-span-2 flex items-center justify-center">
                Resume File
              </th>
            </tr>
          </thead>
          <tbody>
            {getBlogsQuery?.data?.data?.map((item, index) => (
              <tr key={index} className="grid grid-cols-11 w-full">
                <td className="border border-gray-300 px-2 py-2 col-span-1">
                  <Label
                    className="mb-0 text-black text-[15px]"
                    label={`${index + 1}.`}
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 col-span-2">
                  <Label
                    className="mb-0 text-black text-[15px]"
                    label={item.name}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 col-span-2">
                  <Label
                    className="mb-0 w-60 truncate overflow-hidden text-ellipsis whitespace-nowrap   text-[15px]"
                    label={item.phone}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 col-span-2 break-words text-[15px]">
                  <Label className="mb-0" label={item.designation} />
                </td>

                <td className="border border-gray-300 px-4 py-2 col-span-2 flex items-center justify-center">
                  <Download
                    onClick={() => handleDownAssementFile(item.assessment_link)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 col-span-2 flex items-center justify-center">
                  <Download
                    onClick={() => handleDownResumeFile(item.resume_link)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Section>
  );
}
